export default "__VITE_ASSET__D1wiYkM4__"